import { motion, useScroll, useTransform } from 'motion/react'
import { useRef } from 'react'
import styled from 'styled-components'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type ScrollContainerProps = ClassNameProps & ChildrenProps
/**
 * @deprecated Use {FadeOverflow}
 */
export const ScrollContainer: React.FC<ScrollContainerProps> = ({
  className,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { scrollYProgress, scrollY } = useScroll({
    container: containerRef,
    axis: 'y',
  })
  const topOpacity = useTransform(() => {
    return scrollY.get() > 0 ? 1 : 0
  })
  const bottomOpacity = useTransform(() => {
    if (scrollY.get() === 0 && scrollYProgress.get() === 1) {
      return 0
    }
    return scrollY.get() > 0 && scrollYProgress.get() > 0.99 ? 0 : 1
  })

  return (
    <ScrollContainerRoot className={className}>
      <Scrollable data-scrollable ref={containerRef}>
        {children}
        <TopOverlay style={{ opacity: topOpacity }} initial={false} />
        <BottomOverlay style={{ opacity: bottomOpacity }} initial={false} />
      </Scrollable>
    </ScrollContainerRoot>
  )
}

const Scrollable = styled.div`
  overflow-y: auto;
  max-height: 100%;
`

const ScrollContainerRoot = styled.div`
  --overlay-color: var(--appearance-1);
  overflow: hidden;
  position: relative;
`

const TopOverlay = styled(motion.div)`
  position: absolute;
  background: linear-gradient(
    0deg,
    rgba(17, 17, 17, 0) 0%,
    var(--overlay-color) 100%
  );
  pointer-events: none;
  height: 64px;
  top: 0;
  width: 100%;
  transition: all 0.15s linear;
`

const BottomOverlay = styled(motion.div)`
  position: absolute;
  background: linear-gradient(
    0deg,
    var(--overlay-color) 0%,
    rgba(17, 17, 17, 0) 100%
  );
  pointer-events: none;
  height: 108px;
  bottom: 0;
  width: 100%;
  transition: all 0.15s linear;
`
